"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepgramTranscriberLanguage = void 0;
exports.DeepgramTranscriberLanguage = {
    Bg: "bg",
    Ca: "ca",
    Cs: "cs",
    Da: "da",
    DaDk: "da-DK",
    De: "de",
    DeCh: "de-CH",
    El: "el",
    En: "en",
    EnAu: "en-AU",
    EnGb: "en-GB",
    EnIn: "en-IN",
    EnNz: "en-NZ",
    EnUs: "en-US",
    Es: "es",
    Es419: "es-419",
    EsLatam: "es-LATAM",
    Et: "et",
    Fi: "fi",
    Fr: "fr",
    FrCa: "fr-CA",
    Hi: "hi",
    HiLatn: "hi-Latn",
    Hu: "hu",
    Id: "id",
    It: "it",
    Ja: "ja",
    Ko: "ko",
    KoKr: "ko-KR",
    Lt: "lt",
    Lv: "lv",
    Ms: "ms",
    Multi: "multi",
    Nl: "nl",
    NlBe: "nl-BE",
    No: "no",
    Pl: "pl",
    Pt: "pt",
    PtBr: "pt-BR",
    Ro: "ro",
    Ru: "ru",
    Sk: "sk",
    Sv: "sv",
    SvSe: "sv-SE",
    Ta: "ta",
    Taq: "taq",
    Th: "th",
    ThTh: "th-TH",
    Tr: "tr",
    Uk: "uk",
    Vi: "vi",
    Zh: "zh",
    ZhCn: "zh-CN",
    ZhHans: "zh-Hans",
    ZhHant: "zh-Hant",
    ZhTw: "zh-TW",
};
